import {
    Box,
    Checkbox,
    FormControlLabel,
    Tooltip,
    Typography,
} from '@mui/material';
import { Info } from 'lucide-react';
import { useIntl } from 'react-intl';
import { useRecoilState } from 'recoil';
import { pseudonymizeState } from '~/state/atoms/viewerAtoms';

type PseudonymizeCheckboxProps = {
    disabled?: boolean;
};

const PseudonymizeCheckbox = ({
    disabled = false,
}: PseudonymizeCheckboxProps) => {
    const intl = useIntl();
    const [pseudonymizeData, setPseudonymizeState] =
        useRecoilState(pseudonymizeState);

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="end"
            position="relative"
            ml={-1}
        >
            <FormControlLabel
                control={
                    <Checkbox
                        data-testid="pseudonymizeCheckbox"
                        onChange={(_, checked) => setPseudonymizeState(checked)}
                        size="small"
                        color="primary"
                        checked={pseudonymizeData}
                        disabled={disabled}
                    />
                }
                label={
                    <Typography variant="body2" fontSize={13} lineHeight={1}>
                        De-identify data
                    </Typography>
                }
                sx={{ mr: 2 }}
            />
            <Tooltip
                title={
                    <Box p={1} maxWidth={200} whiteSpace="normal">
                        <Typography variant="caption" color="inherit">
                            When enabled, patient data will be de-identified
                            before being sent for processing.
                        </Typography>

                        <Typography variant="body2" fontSize={11} mt={0.5}>
                            Select this if DICOM files contain patient
                            identitying information
                        </Typography>
                    </Box>
                }
                placement="right-start"
            >
                <Box
                    component="span"
                    tabIndex={0}
                    role="img"
                    aria-label={intl.formatMessage({
                        id: 'deIdentifyDataTooltip',
                        defaultMessage:
                            'When enabled, patient data will be de-identified before being sent for processing.',
                    })}
                >
                    <Info size={10} aria-hidden />
                </Box>
            </Tooltip>
        </Box>
    );
};

export default PseudonymizeCheckbox;
